import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getPreviewFiller } from '../../api/fillers/fillers';
export const FillerPicker = ({ width, height, depth, slotType, onSelect, fetchAvailable, onClose }) => {
    const [groups, setGroups] = useState([]);
    const [state, setState] = useState('loading');
    const [activeId, setActiveId] = useState(null);
    const urlStatic = 'https://static.3dp.deallog.pro/';
    useEffect(() => {
        setState('loading');
        fetchAvailable({ width, height, depth, slotType })
            .then(data => { setGroups(data); setState('ready'); })
            .catch(() => setState('error'));
    }, [width, height]);
    const handleSelect = async (id) => {
        setActiveId(id);
        setState('calculating');
        try {
            await onSelect(id);
            setState('ready');
        }
        catch {
            setState('error');
            setActiveId(null);
        }
    };
    // Позиция окна
    const isMobile = window.innerWidth < 768;
    const panelStyle = window.innerWidth < 768 ? {
        position: 'fixed', bottom: 0, left: 0, right: 0,
        maxHeight: '70vh', borderRadius: '16px 16px 0 0',
        boxShadow: '0 -8px 32px rgba(0,0,0,0.18)',
        background: '#fff', zIndex: 1000, overflowY: 'auto', padding: 16,
    } : {
        position: 'fixed', left: 0, top: 0, bottom: 0,
        width: '50vw',
        boxShadow: '8px 0 32px rgba(0,0,0,0.15)',
        background: '#fff', zIndex: 1000, overflowY: 'auto', padding: 24,
    };
    return (_jsxs(_Fragment, { children: [isMobile && (_jsx("div", { onClick: onClose, style: {
                    position: 'fixed', inset: 0,
                    background: 'rgba(0,0,0,0.4)', zIndex: 999
                } })), _jsxs("div", { style: panelStyle, children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'space-between', marginBottom: 12 }, children: [_jsxs("span", { style: { fontWeight: 600, fontSize: 15 }, children: [width.toFixed(2), " \u00D7 ", height.toFixed(2), " \u043C"] }), _jsx("button", { onClick: onClose, style: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#718096' }, children: "\u2715" })] }), state === 'loading' && _jsx("div", { style: { textAlign: 'center', color: '#a0aec0' }, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." }), state === 'error' && _jsx("div", { style: { color: '#e53e3e', textAlign: 'center' }, children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438" }), state === 'ready' && groups.length === 0 && (_jsx("div", { style: { textAlign: 'center', color: '#a0aec0', padding: '24px 0' }, children: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430" })), (groups ?? []).map(group => (_jsxs("div", { style: { marginBottom: 16 }, children: [group.name && (_jsx("div", { style: { fontSize: 11, fontWeight: 700, color: '#a0aec0', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }, children: group.name })), _jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: 8 }, children: (group.items ?? []).map(item => {
                                    const isActive = activeId === item.id;
                                    const isCalculating = state === 'calculating' && isActive;
                                    return (_jsxs("div", { onClick: () => !isCalculating && handleSelect(item.id), style: {
                                            display: 'flex', alignItems: 'center', gap: 10,
                                            padding: '8px 10px', borderRadius: 8,
                                            border: `1.5px solid ${isActive ? '#4488ff' : '#e2e8f0'}`,
                                            background: isActive ? '#ebf4ff' : '#fff',
                                            cursor: isCalculating ? 'wait' : 'pointer',
                                        }, children: [item.preview_url && (_jsx("img", { src: urlStatic + getPreviewFiller(item, "tb"), alt: item.name, style: { width: 200, height: 100, objectFit: 'contain', borderRadius: 6, flexShrink: 0 } })), _jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [_jsx("div", { style: { fontWeight: 600, fontSize: 13, color: '#1a202c' }, children: item.name }), item.description && (_jsx("div", { style: { fontSize: 11, color: '#718096', marginTop: 2 }, children: item.description }))] }), isCalculating
                                                ? _jsx("div", { style: { width: 16, height: 16, border: '2px solid #e2e8f0', borderTop: '2px solid #4488ff', borderRadius: '50%' } })
                                                : isActive
                                                    ? _jsx("span", { style: { color: '#4488ff' }, children: "\u2713" })
                                                    : _jsx("span", { style: { color: '#cbd5e0' }, children: "\u203A" })] }, item.id));
                                }) })] }, group.id ?? 'none')))] })] }));
};
const containerStyle = {
    minWidth: 220,
    maxWidth: 280,
};
const spinnerWrapStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    padding: '12px 0',
};
const spinnerStyle = {
    width: 24,
    height: 24,
    border: '3px solid #e2e8f0',
    borderTop: '3px solid #4488ff',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
};
